<template>
  <v-card class="matter-engagements"
          elevation="2">

    <GeneralTabs :tabs="tabs"
                 class="matter-tabs"
                 @tab-clicked="tabChange"
                 :active-tab="activeTab"
                 touchless
                 :slider-color="tabsColor"
                 :on-hover-color="tabsColor"
                 :disable-hover="false"
                 v-dynamic-slider>
      <v-tab-item v-for="(tab, idx) in tabs"
                  :value="idx"
                  :key="tab.cmp">
        <component :is="tab.cmp"
                   v-if="tab.id === tabs[activeTab].id"
                   :matter="matter"
                   @open-tab="onOpenTab"
                   :is-small-screen="isMobile"/>
      </v-tab-item>
    </GeneralTabs>

  </v-card>
</template>

<script>
  import {GeneralTabs} from "@/modules/common/components";
  import {Conversation, Bookings, Documents} from '@/modules/matters/components';
  import Notes from "./tabs/Notes";
  import Payments from "./tabs/Payments";
  import Docuforms from "./tabs/Docuforms";
  import tabsService from "@/modules/matters/services/tabsService";
  import {mapGetters} from "vuex";
  import _ from 'lodash';

  export default {
    name: "MatterEngagements",
    components: { GeneralTabs, Conversation, Notes, Bookings, Payments, Documents, Docuforms },
    props: {
      matter: {
        type: Object
      },
      chosenTab: {
        type: String
      }
    },
    data() {
      return {
        activeTab: null
      }
    },
    created() {
      const tabIndex = this.tabs.findIndex((tab) => tab.id === this.chosenTab);
      this.activeTab = tabIndex === -1 ? 0 : tabIndex
    },
    computed: {
      ...mapGetters(['isMobile']),
      tabsColor() {
        return this.$store.getters['brandModule/hoverColor']
      },
      tabs() {
        const tabs = tabsService.getTabs(
          'conversation', 'notes', 'bookings',
          this.$hasPermission('can_view_payments') && this.$hasFeature('payments_module') && 'payments',
          this.$hasPermission('can_view_documents') && !this.$hasFeature('new_documents') && 'documents',
          this.$hasPermission('can_view_documents') && this.$hasFeature('new_documents') && 'docuforms'
        );
        return tabs.map(item => _.pick(item, ['id', 'labelKey', 'cmp']));
      }
    },
    methods: {
      tabChange(newTab) {
        this.activeTab = this.tabs.findIndex((tab) => tab.id === newTab.id);
        this.$emit('change', this.tabs[this.activeTab].id);
        this.$track(`Client card ${newTab.id} tab`);
      },
      onOpenTab(event) {
        const newTab = this.tabs.find((tab) => event.tab === tab.id);
        this.tabChange(newTab);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/scss/abstract/_mixins.scss";

  .matter-engagements {
    @include hide-scrollbar;

    &.v-card {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .matter-engagement-tab {
      box-shadow: none;
      height: 100%;
    }

  }
</style>
